module.exports = __webpack_public_path__ + "img/huoban9.cba7f27c.png";